/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionBanUser, ActionUnlockUser} from '../../../store/actions/actions-user';

class ModalChangeUserStatus extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center logout-modal',
      closeButton: true,
      keyboard: true,
    });
  }

  onChangeStatusClick = () => {
    const {status, id} = this.props;

    if (status) {
      this.props.ActionBanUser(id);
    } else {
      this.props.ActionUnlockUser(id);
    }

    this.onCancelClick();
  };

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  render() {
    const {status} = this.props;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <h3 className="logout-title">
              {status ? 'Заблокировать пользователя?' : 'Разблокировать пользователя?'}
            </h3>
            <div className="logout-btn-wrap">
              <button className="btn btn-conture btn-block" onClick={this.onCancelClick}>Отмена</button>
              <button className="btn btn-base btn-block" onClick={this.onChangeStatusClick}>
                {status ? 'Заблокировать' : 'Разблокировать'}
              </button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalChangeUserStatus.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionBanUser,
    ActionUnlockUser,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ModalChangeUserStatus);
